import React, { FunctionComponent } from 'react';
import { FormField } from '../../types';
import { FormFields } from '../formFields/FormFields';

type Props = {
  phase2FormFields: FormField[] | 'not_initialized';
};

export const Phase2FormFields: FunctionComponent<Props> = ({
  phase2FormFields,
}) => {
  return (
    <div>
      <FormFields fields={phase2FormFields} formId={'phase2FormFields'} />
    </div>
  );
};
